import React, { Component } from 'react';
import { translate } from 'react-i18next';


class PassportFactoryField extends Component {

  constructor(props) {
    super(props);
    this.state = {
    }

  }

  renderText = (field,placeholder) => {
    return(
      <input       
            disabled={this.props.disabled}
            className="form-control"   
            id={field.id}
            placeholder={placeholder}
            type="text"
            onChange={this.props.handleChange}
            value={field.value ? field.value : " "}  />
    );
  }

  renderDate = (field,placeholder) => {
    return(
      <input
            disabled={this.props.disabled}
            className="form-control"
            autoComplete="off"
            id={field.id}
            placeholder={placeholder}
            type="text"
            onChange={this.props.handleChange}
            value={field.value ? field.value : " "} />
    );
  }

  renderOptions = (field) => {    
    return(
      <select 
              className="form-control"
              disabled={this.props.disabled}
              id={field.id}
              onChange={this.props.handleChange}
              value={field.value ? field.value : " "}>
              { field.options_available.map((option, i) => 
                          <option value={option.id} key={i}> {this.props.t(option.name)} </option>)
              }
      </select>
    );
  }

  renderRadios = (field) => {
    return(
      <div className="radio-group">
         { field.options_available.map((option, i) =>                        
            <label className="radio-inline" key={option.id} >
                          <input
                            disabled={this.props.disabled}
                            checked={option.id === field.value}
                            name={field.id}                           
                            type="radio"
                            onChange={this.props.handleRadioChange}
                            value={option.id} />
                          {this.props.t(option.name)}
            </label>
                          )
            
          }

      </div>
    );
  }

  renderTextArea = (field,placeholder) => {
    return(
      <textarea
          className="form-control"
          disabled={this.props.disabled}
          id={field.id}
          placeholder={placeholder}
          rows="3"
          onChange={this.props.handleChange}
          value={field.value} />
    );
  }

  getField = (field) => {
    switch (field.type) {
      case "text":
        return this.renderText(field,this.props.holder);
      case "date":
        return this.renderDate(field,this.props.holder);
      case "options":
          return this.renderOptions(field);
      case "radio":
          return this.renderRadios(field);
      case "text_area":
        return this.renderTextArea(field,this.props.holder)
    }
  }

  render() {
    return(this.getField(this.props.field));
   
  }
}

export default translate('common')(PassportFactoryField);



// WEBPACK FOOTER //
// ./src/dashboard/profile/PassportFactoryField.js